import { TenantProvider } from '@emerald-works-nova/auth'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'
import React, { useCallback, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { AppLoading, TenantError } from './components'
import './i18n'
import consts from './consts'
import store from './reducers/store'
import { ApplicationRouterProvider } from './router/router'
import * as serviceWorker from './serviceWorker'
import { createTheme } from './theme'

// Guard against non-JSON WebSocket keepalive frames (e.g. "PING") that
// cause SyntaxError when the event-bus-client tries to JSON.parse them.
// This prevents the uncaught exception from crashing React or failing E2E tests.
window.addEventListener('error', (event) => {
  if (event.error instanceof SyntaxError && event.error.message.includes('is not valid JSON')) {
    event.preventDefault()
    console.warn('Suppressed non-JSON WebSocket parse error:', event.error.message)
  }
})

const container = document.getElementById('root')
const root = createRoot(container)

const Main = () => {
  const [theme, setTheme] = useState(createTheme())

  const onChangeMainColor = useCallback((color) => {
    setTheme(createTheme({ palette: { primary: { main: color } } }))
  }, [])

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <TenantProvider
            ErrorComponent={TenantError}
            LoadingComponent={AppLoading}
            defaultTenantKey={consts.DEFAULT_CLUB_TENANT_KEY}
          >
            <ApplicationRouterProvider
              onChangeMainColor={onChangeMainColor}
            />
          </TenantProvider>
        </Provider>
      </ThemeProvider>
    </StyledEngineProvider>
  )
}

root.render(<Main />)

// expose store when run in Cypress
if (window.Cypress) {
  window.store = store
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
